var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73828 1.74805H12.2337V5.24342",
    stroke: "#FB2C36",
    strokeWidth: 1.16513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8252 8.15623L12.2334 1.74805",
    stroke: "#FB2C36",
    strokeWidth: 1.16513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4865 7.57403V11.0694C10.4865 11.3784 10.3637 11.6748 10.1452 11.8933C9.92672 12.1118 9.63037 12.2345 9.32136 12.2345H2.91317C2.60416 12.2345 2.30781 12.1118 2.0893 11.8933C1.8708 11.6748 1.74805 11.3784 1.74805 11.0694V4.66122C1.74805 4.35221 1.8708 4.05585 2.0893 3.83735C2.30781 3.61885 2.60416 3.49609 2.91317 3.49609H6.40855",
    stroke: "#FB2C36",
    strokeWidth: 1.16513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkYoutube);
export default __webpack_public_path__ + "static/media/link_youtube.9837c12ed4f6af4c210efdc0c9a84851.svg";
export { ForwardRef as ReactComponent };